module.exports = __webpack_public_path__ + "static/media/imageBot.75256c41.png";